import React from 'react'
import InputField from '../../../sharedcomponents/1elements/Fields/InputField'
import { makeStyles } from '@material-ui/core/styles'
import UniversalAddress from '../../../sharedcomponents/2compounds/UniversalAddress'

const LeftChild = ({
  formikProps,
  editMode,
  createMode,
  assetTypes,
  onTypeChange,
  entities
}) => {
  const classes = useStyles()
  const values = formikProps.values

  const setGeoFromAddress = ({ lat, long }) => {
    if (lat === null || lat === undefined || lat === '' ||
      long === null || long === undefined || long === '') return

    const latitude = Number(lat)
    const longitude = Number(long)

    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return

    formikProps.setFieldValue('geo.lat', latitude, false)
    formikProps.setFieldValue('geo.long', longitude, false)
  }

  return (
    <div className={classes.root}>
      <div className={classes.top}>
        <div className={classes.leftPanel}>
          <InputField
            type='text'
            name='name'
            label='Location Name'
            value={values?.name}
            required={true}
            editMode={editMode}
          />
          <InputField
            type='select'
            name='type_id'
            required={true}
            label='Location Type'
            setFieldValue={formikProps.setFieldValue}
            options={
              assetTypes &&
              assetTypes.map(oneOption => ({
                key: oneOption.id,
                value: oneOption.id,
                text: oneOption.name
              }))
            }
            value={values?.type_id}
            editMode={editMode}
            onChange={onTypeChange}
          />

          <InputField
            type='phone'
            name='phone'
            label='Phone Number'
            value={values?.phone}
            values={values}
            setFieldValue={formikProps.setFieldValue}
            editMode={editMode}
          />
          <InputField
            type='select'
            name='entity_id'
            required={true}
            label='Entity Name'
            setFieldValue={formikProps.setFieldValue}
            options={
              entities &&
              entities.map(oneOption => ({
                key: oneOption.id,
                value: oneOption.id,
                text: oneOption.name
              }))
            }
            value={values?.entity_id}
            editMode={editMode}
          />
        </div>
        <div className={classes.rightPanel}>
          <UniversalAddress
            values={formikProps.values}
            editMode={editMode}
            setFieldValue={formikProps.setFieldValue}
            addressIsInArray={false}
            allowManualLatLongOverride={true}
            setGeo={setGeoFromAddress}
          />
        </div>
      </div>
    </div>
  )
}

export default LeftChild

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    '& >*': {
      boxSizing: 'border-box'
    }
  },
  top: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row'
  },
  bottom: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '25px'
  },
  leftPanel: {
    width: '60%',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 10px 0 0'
  },
  rightPanel: {
    width: '40%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 0 0 10px'
  },
  nameWrapper: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  nameItem: {
    width: '50%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }
}))
